import { useCallback } from 'react';

import { useApplicationBuildContext } from '@context/ApplicationBuildContext';
import { formatUrl } from '@utils/text';

export const useFormatCdnRoute = () => {
  const {
    settings: { cdnBaseUrlAddress },
  } = useApplicationBuildContext();

  return useCallback(
    (path: string, routePrefix?: string) =>
      formatUrl({ urlBase: cdnBaseUrlAddress, path: formatUrl({ urlBase: routePrefix ?? '', path: path }) }),
    [cdnBaseUrlAddress],
  );
};
